import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

if (environment.production) {
  enableProdMode();
}

if (environment.version !== 'local') {
  initializeFaro({
    url: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/da239fc300a1c2ae8cbfb941fde6bd52',
    app: {
      name: 'btn-web-app',
      version: '1.0.0',
      environment: environment.production ? 'production' : 'development'
    },
    instrumentations: [
      // Mandatory, omits default instrumentations otherwise.
      ...getWebInstrumentations(),
      // Tracing package to get end-to-end visibility for HTTP requests.
      new TracingInstrumentation()
    ]
  });
}
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(() => console.error());
